import React, { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import ConfirmModal, { ConfirmModalActionPair } from 'atom-components/confirm-modal';
import FullName from 'feature-components/full-name';
import { countMessages } from 'pages/marking/helpers/marker.helpers';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import type { ManageMarkingMark } from 'services/assist-api/entities/test-instance-response-mark/types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (intendedMarkerId: number) => void;
  organisationUsers: BaseCustomerUser[];
  intendedMarkerId: number;
  marksOfResponse: ManageMarkingMark[];
};

export default function ConfirmMarkerChangeModal({
  isOpen,
  onClose,
  onConfirm,
  organisationUsers,
  intendedMarkerId,
  marksOfResponse
}: Props): ReactElement {
  const { watch } = useFormContext();
  const intendedOrganisationUserId = watch('organisationUserId');
  const intendedOrganisationUser = organisationUsers.find(
    (ou) => ou.id === intendedOrganisationUserId
  );

  const markerName = <FullName organisationUser={intendedOrganisationUser} bringAttentionTo />;

  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Confirm Marker Change"
      handleClickCancel={onClose}
      handleClickOK={(): void => onConfirm(intendedMarkerId)}
      actionPair={ConfirmModalActionPair.Custom}
      buttonTitleOK="Confirm Marker Change"
      buttonTitleCancel="Cancel"
    >
      <p>
        {markerName} is already the active marker of{' '}
        {countMessages(intendedMarkerId, marksOfResponse)} of this response.
      </p>
      <p>Are you sure you want to make {markerName} the active marker?</p>
    </ConfirmModal>
  );
}
